import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ed714624")

_pushScopeId("data-v-ed714624")
const _hoisted_1 = { class: "container mt-6" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "My templates", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Create ")
const _hoisted_5 = /*#__PURE__*/_createVNode("strong", null, "Day Templates", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" to easily manage ")
const _hoisted_7 = /*#__PURE__*/_createVNode("strong", null, "Work Periods", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" in ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("your timeline")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("! ")
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_12 = { class: "is-flex is-flex-wrap-wrap" }
const _hoisted_13 = /*#__PURE__*/_createVNode("a", { class: "icon-text card-footer-item" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon is-large" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-lg fa-calendar-day" })
  ]),
  /*#__PURE__*/_createVNode("span", { class: "subtitle is-size-4" }, "Add Template")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_day_template_preview = _resolveComponent("day-template-preview")
  const _component_loader = _resolveComponent("loader")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", null, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_router_link, { to: "my-work" }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10
      ]),
      _hoisted_11,
      _createVNode(_component_loader, { "is-loading": _ctx.isLoading }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_12, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dayTemplates, (dayTemplate) => {
              return (_openBlock(), _createBlock(_component_day_template_preview, {
                key: dayTemplate.id,
                dayTemplate: dayTemplate,
                onRemove: _ctx.onTemplateRemove,
                editable: "",
                class: "item"
              }, null, 8, ["dayTemplate", "onRemove"]))
            }), 128)),
            _createVNode(_component_router_link, {
              class: "box create-button item",
              to: "/my-templates/create"
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["is-loading"])
    ])
  ]))
})